<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <CustomerForm
          v-model="customer"
          title="Editace zákazníka"
          :edit="true"
          :loading="loading"
          :saving="saving"
          @save="save"
        />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapActions } from 'vuex'
import CustomerForm from '@/components/forms/CustomerForm'

export default {
  name: 'CustomerEdit',
  components: {
    CustomerForm,
  },
  data() {
    return {
      customer: {},
      loading: false,
      saving: false,
    }
  },
  created() {
    this.loadCustomer()
  },
  methods: {
    ...mapActions({
      getCustomer: 'customer/getCustomer',
      updateCustomer: 'customer/updateCustomer',
    }),
    loadCustomer() {
      this.loading = true
      this.getCustomer(this.$route.params.customerId)
        .then((response) => {
          this.customer = response.data
        })
        .finally(() => {
          this.loading = false
        })
    },
    save() {
      this.saving = true
      this.updateCustomer(this.customer)
        .then((response) => {
          if (response.status === 200 || response.status === 201) {
            this.$router.push({
              name: 'customers.detail',
              params: { id: this.customer.customerId },
            })
          }
        })
        .finally(() => {
          this.saving = false
        })
    },
  },
}
</script>
